<template>
  <div>
    <v-layout row wrap>
      <v-flex md12>
        <h2>Profile</h2>
        <v-card tile>
          <v-tabs
            show-arrows
            v-model="selectedTab"
          >
            <v-tab href="#profile-tab">
              Profile
            </v-tab>
            <v-tab href="#courses-tab">
              Courses
            </v-tab>
            <v-tab href="#stats-tab">
              Stats
            </v-tab>
            <v-spacer></v-spacer>
            <v-tabs-items>
              <v-tab-item id="profile-tab">
                <v-layout row wrap>
                  <v-flex md12 v-if="userData">

                    <v-list>
                      <v-list-tile ripple>
                        <v-flex xs4 md2>
                          <h5><b>Name</b></h5>
                        </v-flex>
                        <v-flex xs9 md10>
                          {{ userData.name }}
                        </v-flex>
                      </v-list-tile>
                      <v-list-tile ripple>
                        <v-flex xs4 md2>
                          <h5><b>Email</b></h5>
                        </v-flex>
                        <v-flex xs9 md10>
                          {{ userData.email }}
                        </v-flex>
                      </v-list-tile>
                      <v-list-tile ripple>
                        <v-flex xs4 md2>
                          <h5><b>Phone</b></h5>
                        </v-flex>
                        <v-flex xs9 md10>
                          {{ userData.phone }}
                        </v-flex>
                      </v-list-tile>
                    </v-list>

                      <v-flex v-if="$store.getters.currentUserRoles.includes('vendor')" mt-2 ml-3>

                        <v-flex xs12 tag="h4" mb-5>
                          Products
                        </v-flex>
                        <v-data-table
                          :items="productsList"
                          hide-actions
                          hide-headers
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.name }}</td>
                            <td>${{ props.item.price }}</td>
                            <td>{{ props.item.category.name }}</td>
                          </template>
                        </v-data-table>
                      </v-flex>

                      <v-flex v-if="$store.getters.currentUserRoles.includes('case-manager')" mt-2 ml-3>
                        <v-flex xs12 tag="h4" mb-5>
                          Commissions (total for now ${{ totalCommission }})
                        </v-flex>
                      </v-flex>
                      <v-flex v-for="(workCase, i) in casesList" :key="i" mb-5>
                        <v-flex tag="b">
                          Case ID # {{ workCase.id }}
                        </v-flex>
                        <v-flex xs8 mt-3>
                          <v-data-table
                            :items="workCase.products"
                            :headers="productsTableHeaders"
                            hide-actions
                          >
                            <template slot="items" slot-scope="props">
                              <td>{{ props.item.name }}</td>
                              <td>${{ props.item.commission }}</td>
                              <td>{{ props.item.invoice_updated }}</td>
                            </template>
                            <template slot="footer">
                              <v-flex mt-5 ml-3>
                                <b>Total commission for case:</b> ${{ calculcateCaseCommission(workCase.id) }}
                              </v-flex>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-flex>
                  </v-flex>
                  <v-flex md12>
                    <v-btn @click="refresh()">
                      Hard Refresh
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-tab-item>
              <v-tab-item id="courses-tab">
                <v-layout row wrap v-if="userData">
                  <v-flex md12>
                    <v-card tile>

                      <v-list>
                      <v-list-tile ripple>
                        <v-flex xs4 md2>
                          <h5><b>Edx Completion Percent</b></h5>
                        </v-flex>
                      </v-list-tile>
                      </v-list>

                      <v-data-table
                        :items="courses"
                        :headers="coursesTableHeaders"
                        hide-actions
                      >
                        <template slot="items" slot-scope="props">
                          <td>{{ props.item.course_id.replace(/\+/g, " ") }}</td>
                          <td>{{ (Number(props.item.earned_all / props.item.possible_all).toFixed(2) * 100).toFixed(0) }}</td>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-tab-item>
              <v-tab-item id="stats-tab">
                <v-layout row wrap>
                  <v-flex md12 v-if="statData">
                    <div class="stat-lead-row" ripple v-if="$store.getters.currentUserRoles.includes('dispatcher') || $store.getters.currentUserRoles.includes('management')">
                      <v-flex>
                        <h5><b>Total leads by month:</b></h5>
                      </v-flex>
                      <v-flex>
                        <div class="leadsTable">
                          <div v-for="(leadItem, index) in leadsData" class="leadsTable__item">
                            <div class="leadsTable__item__month">{{ leadItem.name }}</div>
                            <div class="leadsTable__item__count">{{ leadItem.value }}</div>
                          </div>
                        </div>
                      </v-flex>
                    </div>
                    <div class="stat-lead-row" ripple v-if="$store.getters.currentUserRoles.includes('case-manager')">
                      <v-flex>
                        <h5><b>Your cases:</b></h5>
                      </v-flex>
                      <v-flex>
                        <div class="leadsTable">
                          <div v-for="(caseItem, index) in casesData" class="leadsTable__item">
                            <div class="leadsTable__item__month">{{ caseItem.name }}</div>
                            <div class="leadsTable__item__count">{{ caseItem.value }}</div>
                          </div>
                        </div>
                      </v-flex>
                    </div>
                    <div class="stat-lead-row" ripple v-if="$store.getters.currentUserRoles.includes('case-crew')">
                      <v-flex>
                        <h5><b>Participating in cases:</b></h5>
                      </v-flex>
                      <v-flex>
                        <div class="leadsTable">
                          <div v-for="(leadItem, index) in partiCasessData" class="leadsTable__item">
                            <div class="leadsTable__item__month">{{ leadItem.name }}</div>
                            <div class="leadsTable__item__count">{{ leadItem.value }}</div>
                          </div>
                        </div>
                      </v-flex>
                    </div>
                  </v-flex>
                </v-layout>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>

        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script type="text/javascript">
  import usersAPI from '@/api/user'
  import _ from 'lodash'

  export default {
    data () {
      return {
        productsTableHeaders: [
          { text: 'Product Name', value: 'name' },
          { text: 'Commission', value: 'commission' },
          { text: 'Invoice Paid', value: 'invoice_updated' }
        ],
        coursesTableHeaders: [
          { text: 'Course Name', value: 'course_id' },
          { text: 'Completed %', value: 'earned_all' }
        ],
        userData: null,
        productsList: [],
        casesList: [],
        statData: [],
        leadsData: [],
        casesData: [],
        partiCasessData: [],
        selectedTab: 0
      }
    },
    computed: {
      courses () {
        let result = []
        _.each(JSON.parse(this.userData.courses_completion_percent), (value, key) => {
          return Array.prototype.push.apply(result, value)
        })
        return result
      },
      totalCommission () {
        return this.casesList.reduce((total, workCase) => total + workCase.products.reduce((accum, product) => accum + product.commission, 0), 0)
      }
    },
    methods: {
      calculcateCaseCommission (caseId) {
        return this.casesList.find(finding => finding.id === caseId).products.reduce((accum, product) => accum + product.commission, 0)
      },
      refresh () {
        location.reload(true)
      },
      formatLeads (data) {
        let array = []
        for (const [key, value] of Object.entries(data)) {
          let filteredList = [...new Set(value.map(i => i.cases_id))]
          array.push({
            name: key,
            value: filteredList.length
          })
        }
        return array
      }
    },
    created () {
      usersAPI.getCurrentUser().then(result => {
        this.userData = result
      }, () => {})

      if (this.$store.getters.currentUserRoles.includes('vendor')) {
        usersAPI.getLinkedProducts(this.$store.getters.currentUser.id).then(result => {
          this.productsList = result
        }, () => {})
      }

      if (this.$store.getters.currentUserRoles.includes('case-manager')) {
        usersAPI.getCaseManagersLinkedCasesAndProducts(this.$store.getters.currentUser.id).then(result => {
          this.casesList = result
        }, () => {})
      }

      this.$store.dispatch('getUserStat').then((res) => {
        this.leadsData = this.formatLeads(res.leads)
        this.casesData = this.formatLeads(res.manager_in_cases)
        this.partiCasessData = this.formatLeads(res.participating_in)
        this.statData = res
      })
    }
  }
</script>

<style scoped>
  h2 {
    text-transform: uppercase;
    font-weight: normal;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
    padding-bottom: 10px;
    position: relative;
    font-size: 18px;
  }
  h2:after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: #fff;
    position: absolute;
    bottom: -2px;
  }

  .stat-lead-row {
    margin: 12px 12px 30px;
  }
  .stat-lead-row h5 {
    text-transform: uppercase;
    margin-bottom: 5px;
    font-size: 13px;
  }
  .leadsTable {
    display: flex;
  }
  .leadsTable__item {
    border: 1px solid #ccc;
    padding: 5px 0;
    font-size: 12px;
    font-weight: bold;
    margin-right: -1px;
    text-align: center;
    width: calc(100%/12);
  }
</style>



// WEBPACK FOOTER //
// Profile.vue?44174b97